import moment from "moment";

import { formatThaiDateUi, getCreateDateTime } from "../../utils/DateUtils";

export const soMasterModel = () => {
  return {
    docId: null,
    compId: null,
    docNo: null,
    docDate: formatThaiDateUi(moment()),
    docStatus: parseInt("1", 10),
    docStatusTransport: parseInt("3", 10),
    docStatusReceive: parseInt("3", 10),
    docCode: parseInt("7", 10),
    docType: parseInt("6", 10),
    docFor: parseInt("1", 10),
    docIsPickingList: 0,
    docIsInv: "N",
    docInvNo: null,
    docIsInvFrom: null,
    refDocID: null,
    refDoc: null,
    refDocDate: null,
    refProjectID: null,
    refProjectNo: null,
    transportType: parseInt("1", 10),
    docRemark1: null,
    docRemark2: null,
    arID: null,
    arCode: null,
    arName: null,
    doc_due_date: moment().format("YYYY-MM-DD"),
    actionHold: parseInt("0", 10),
    discountValue: parseInt("0", 10),
    discountValueType: null,
    discountValueTotal: parseFloat("0.00"),
    discountCash: parseFloat("0.00"),
    discountCashType: null,
    discountTransport: parseFloat("0.00"),
    discountTransportType: null,
    isVat: null,
    docSEQ: null,
    creditTerm: null,
    creditTerm1Day: parseInt("0", 10),
    creditTerm1Remark: null,
    creditTerm2Remark: null,
    accCode: "0000",
    empName: null,
    createdDate: getCreateDateTime(),
    createdByName: window.localStorage.getItem("name"),
    createdById: window.localStorage.getItem("emp_id"),
    updateDate: null,
    updateByName: null,
    updateById: null,
    approvedDate: null,
    approvedByName: null,
    approvedById: null,
    cancelDate: null,
    cancelByName: null,
    cancelById: null,
    approvedMemo: null,
    printedStatus: "N",
    printedDate: null,
    printedBy: null,
    docPaidPic: null,
    payTotal: parseFloat("0.00"),
    refBillNo: null,
    dateSend: moment().format("YYYY-MM-DD"),
    placeDelivery: null,
    placeDelivery2: null,
    credit: null,
    credit_Term: null,
    saleName: null,
    refBilldate: formatThaiDateUi(moment()),
    isCutSTC: null,
    isCutSTC_INVno: null,
  };
};
